<template>
    <div class="layout">
        <div id="layout-title">
            <div id="layout-title-left">
                <img src="/static/imgs/dianpu.png" class="jxyd-imgicon" />
                店铺信息
            </div>
            <div id="layout-title-right">
                <button class="jxyd-button" title="新建店铺" @click="addStore" style="margin-right:10px;" v-show="permission.isAdd">
                    <Icon type="md-add-circle" size='18'/> 新建
                </button>
                <button class="jxyd-button" title="删除店铺" @click="deleteStore" v-show="permission.isDelete">
                    <Icon type="md-trash" size='18'/> 删除
                </button>
            </div>
        </div>
        <div id="layout-box">
            <div id="box-search">
                <Form ref="formSearch" :model="searchItems" inline>
                    <FormItem>
                        <Input type="text" v-model="searchItems.shopName" placeholder="输入编号/店铺名/备注" @keyup.enter.native="initListData(1)" />
                    </FormItem>
                    <FormItem>
                        <button class="jxyd-button jxyd-primary" @click="initListData(1)">查询</button>
                    </FormItem>
                </Form>
            </div>
            <div id="box-table">
                <Table ref="storeList" :columns="tableColumns" :data="storeData" @on-selection-change="storeListSeleChange"></Table>
            </div>
            <div id="page-box">
                <Page :total="storeCount" :page-size="searchItems.pageSize"
                      @on-change="pageChange" show-total
                      :current="searchItems.pageIndex"
                      style="display:inline-block;">
                </Page>
            </div>
        </div>

        <Modal v-model="modalDisPlay" draggable sticky scrollable>
            <p slot="header" class="modal-header">
                <img src="/static/imgs/dianpu.png" class="jxyd-imgicon" />
                <span> 操作店铺</span>
            </p>
            <div style="background-color:#fff;padding:20px;border-radius:5px;">
                <Form ref="formStore" :model="formItem" :label-width="70" :rules="ruleStore">
                    <Form-item label="店铺名" prop="shopName">
                        <Input v-model="formItem.shopName" placeholder="请输入" size="large" />
                    </Form-item>
					<Form-item label="店铺编号" prop="code">
					    <Input v-model="formItem.code" :disabled="true" placeholder="请输入" size="large" />
					</Form-item>
                    <Form-item label="是否启用">
                        <i-Switch v-model="formItem.isUse" size="large" />
                    </Form-item>
                    <Form-item label="备注" prop="note">
                        <Input v-model="formItem.note" type="textarea" placeholder="请输入" size="large" />
                    </Form-item>
                </Form>
            </div>
            <div slot="footer">
                <button class="jxyd-button" @click="cancel('formStore')">取消</button>
                <button class="jxyd-button jxyd-primary" @click="storeSubmit('formStore')">保存</button>
            </div>
        </Modal>

        <Modal v-model="modalUser" draggable sticky scrollable>
            <p slot="header" class="modal-header">
                <img src="/static/imgs/guanlirenyuan.png" class="jxyd-imgicon" />
                <span> 管理人员</span>
            </p>
            <div style="background-color:#fff;border-radius:5px;">
                <div style="padding:25px;">
                    <userList ref="userList" :selectedUsers="selectedUsers"></userList>
                </div>
            </div>
            <div slot="footer">
                <button class="jxyd-button" @click="modalUser = false;">取消</button>
                <button class="jxyd-button jxyd-primary" @click="userItemSubmit">保存</button>
            </div>
        </Modal>
    </div>
</template>

<script>
    import request from '@/utils/request'
    import userList from '@/views/SystemManage/userList'

    export default {
        name: 'storemanage',
        components: {
            userList
        },
        data() {
            return {
                searchItems: {
                	shopName: '',
                	code:'',
                	Note:'',
                	pageSize: 11,
                	pageIndex: 1
                },
                storeRowId:0,
                storeCount: 0,
                modalDisPlay: false,
                modalUser: false,
                tableColumns: [
                    {
                        type: 'selection',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: '店铺名',
                        key: 'shopName'
                    },
					{
					    title: '店铺编号',
					    key: 'code'
					},
                    {
                        title: '是否启用',
                        key: 'isUse',
                        render: (h,params) => {
                            return h('i-Switch', {
                                attrs: {
                                    'value': params.row.isUse,
                                    'disabled': !this.permission.isUpdateUse
                                },
                                on: {
                                    'on-change': (e) => {
                                        params.row.isUse = e;
                                        let self = this;
                                        let tag = '';
                                        if (e) {
                                            tag = '启用';
                                        } else {
                                            tag = '停用';
                                        }
                                        this.$Modal.confirm({
                                            title: "操作警告",
                                            content: "是否确认" + tag + "“" + params.row.shopName + "”店铺？",
                                            onOk() {
                                                request.post('/api/WorkShop/EditWorkShop', params.row).then(function (response) {
                                                    if (response.state == 0) {
                                                        self.$Notice.error({
                                                            title: '错误提示',duration: 3,
                                                            desc: '更新失败:' + response.errorMsg
                                                        });
                                                        return;
                                                    }
                                                    self.$Notice.success({
                                                        title: '正确提示',duration: 3,
                                                        desc: '更新成功!'
                                                    });
                                                }).catch(function (error) {
                                                    params.row.isUse = !e;
                                                })
                                            },
                                            onCancel() {
                                                params.row.isUse = !e;
                                            }
                                        });
                                    }
                                }
                            })
                        }
                    },
                    {
                        title: '备注',
                        key: 'note'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        width: 200,
                        align: 'center',
                        fixed: 'right',
                        render: (h, params) => {
                            let funcList = [];
                            if (this.permission.isEdit) {
                                funcList.push(h('i-button', {
                                    style: {
                                        'margin-right': '5px'
                                    },
                                    attrs: {
                                        type: `primary`,
                                        class: "ivu-btn ivu-btn-primary ivu-btn-small"
                                    },
                                    on: {
                                        click: (e) => {
                                            this.initForm(params.row);
                                            this.modalDisPlay = true;
                                        }
                                    },
                                }, "编辑"));
                            }

                            if (this.permission.isSelectUser) {
                                funcList.push(h('i-button', {
                                    style: {
                                        'margin-right': '5px'
                                    },
                                    attrs: {
                                        type: `error`,
                                        class: "ivu-btn ivu-btn-error ivu-btn-small"
                                    },
                                    on: {
                                        click: (e) => {
                                            this.storeRowId = params.row.id;
                                            this.getSelectedUser(params.row.id);
                                            this.modalUser = true;
                                        }
                                    }
                                }, "人员"));
                            }
                            return funcList;
                        }
                    }
                ],
                storeData: [],
                formItem: {
                    id: 0,
                    shopName: '',
					code:'',
                    isUse: true,
                    note: '',
                    creator: parseInt(localStorage.getItem("userId"))
                },
                ruleStore: {
                    shopName: [
                        { required: true, message: '请填写店铺名', trigger: 'blur' },
                        { type: 'string', max: 20, message: '输入不得大于20个字', trigger: 'blur' }
                    ],
                    note: [
                        { required: false, message: '', trigger: 'blur' },
                        { type: 'string', max: 50, message: '输入不得大于50个字', trigger: 'blur' }
                    ]
                },
                tableRowIds: [],
                selectedUsers: [],
                permission: {
                    isAdd: false,
                    isEdit: false,
                    isDelete: false,
                    isUpdateUse: false,
                    isSelectUser: false
                }
            }
        },
        methods: {
            initListData(index) {
                let component = this;
				this.tableRowIds = []
                component.searchItems.pageIndex = index;
                request.post('/api/WorkShop/GetWorkShopList', component.searchItems).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    component.storeData = response.data.list;
                    component.storeCount = response.data.listCount;
                }).catch(function (error) {
                })
            },
            initForm(data) {
                this.formItem.id = data.id;
                this.formItem.code = data.code;
                this.formItem.shopName = data.shopName;
                this.formItem.isUse = data.isUse;
                this.formItem.note = data.note;
                this.formItem.creator = data.creator;
            },
            storeSubmit(name) {
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        let component = this;
                        request.post('/api/WorkShop/EditWorkShop', component.formItem).then(function (response) {
                            if (response.state == 0) {
                                component.$Notice.error({
                                    title: '错误提示',duration: 3,
                                    desc: '保存失败:' + response.errorMsg
                                });
                                return;
                            }
                            //清空form规则检查
                            component.modalDisPlay = false;
                            component.initListData(1);
                            component.$Notice.success({
                                title: '正确提示',duration: 3,
                                desc: '保存成功!'
                            });

                        }).catch(function (error) {
                        })
                    }
                })
            },
            cancel(name) {
                this.modalDisPlay = false;
                //清空form规则检查
                this.$refs[name].resetFields();
            },
            userItemSubmit() {
                let array = this.$refs.userList.targetKeys;

                let userModel = { shop: this.storeRowId, user: array, creator: parseInt(localStorage.getItem("userId")) };

                let component = this;
                request.post('/api/ShopToUser/AddShopToUser', userModel).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: '保存失败:' + response.errorMsg
                        });
                        return;
                    }

                    component.modalUser = false;
                    component.$Notice.success({
                        title: '正确提示',duration: 3,
                        desc: '保存成功!'
                    });

                }).catch(function (error) {
                })
            },
            addStore() {
                this.modalDisPlay = true;
                this.$refs['formStore'].resetFields();
				this.getNextCode()
                this.formItem.id = 0;
            },
            storeListSeleChange(items) {
                this.tableRowIds = [];
                for (let i = 0; i < items.length; i++) {
                    this.tableRowIds.push(items[i].code);
                }
            },
            deleteStore() {
                if (this.tableRowIds.length <= 0) {
                    this.$Notice.error({
                        title: '错误提示',duration: 3,
                        desc: '请选中要删除的店铺！'
                    });
                    return;
                }
                let component = this;
                this.$Modal.confirm({
                    title: "操作警告",
                    content: "店铺删除后不可恢复，是否继续操作？",
                    onOk() {
                        request.get('/api/WorkShop/DeleWorkShop', {
							params:{
								codes:component.tableRowIds.join(',')
							}
						}).then(function (response) {
                            if (response.state == 0) {
                                component.$Notice.error({
                                    title: '错误提示',duration: 3,
                                    desc: response.errorMsg
                                });
                                return;
                            }
                            component.initListData(1);
                        }).catch(function (error) {
                        })
                    },
                    onCancel() {
                    }
                });
            },
            pageChange(index) {
                this.initListData(index);
            },
            getSelectedUser(storeId) {
                let component = this;
                request.get('/api/ShopToUser/GetUserOfShop', {
                    params: {
                        shopId: storeId
                    }
                }).then(function (response) {
                    if (response.state == 0) {
                        component.$Notice.error({
                            title: '错误提示',duration: 3,
                            desc: "获取数据失败：" + response.errorMsg
                        });
                        return;
                    }
                    component.selectedUsers = response.data;
                }).catch(function (error) {
                })
            },
			getNextCode() {
				let self = this;
				request.get('/api/WorkShop/GetNextCode', {
					params: {
						prefix: 'DP'
					}
				}).then(function(response) {
					if (response.state == 0) {
						component.$Notice.error({
						    title: '错误提示',duration: 3,
						    desc: "获取编号失败：" + response.errorMsg
						});
						return
					}
					self.formItem.code = response.data
				}).catch(function(error) {})
			},
            initPermission() {
                let self = this;
                let params = {
                    funcCodes: ['Shop.Add','Shop.Edit','Shop.Delete','Shop.UpdateUse','Shop.SelectUser','Shop.ConfigFunc'],
                    userId: parseInt(localStorage.getItem("userId"))
                };
                request.post('/api/Function/VerifyPermissions', params).then(function (response) {
                    let tipTimeoutCount = localStorage.getItem("_tipTimeoutCount")
					if(tipTimeoutCount != undefined){
						tipTimeoutCount = parseInt(tipTimeoutCount);
					}
                    if (response.state == 0) {
                    	self.$Notice.error({
                    		title: '错误提示',
                    		duration: 3,
                    		desc: "获取权限数据失败：" + response.errorMsg
                    	});
                    	return;
                    }else if(response.state == 2 && (tipTimeoutCount == undefined || tipTimeoutCount >= 1000)){
                    	self.$Modal.warning({
                    		title:'系统到期提示',
                    		content: response.errorMsg,
                    		onOk:() => {
                    			localStorage.setItem("_tipTimeoutCount",1);
                    		}
                    	});
                    }
                    if(tipTimeoutCount == undefined || tipTimeoutCount < 1000){
                    	localStorage.setItem("_tipTimeoutCount",tipTimeoutCount == undefined ? 1 : tipTimeoutCount+1)
                    }

                    for (var i = 0; i < response.data.length; i++) {
                        
                        switch (response.data[i].funcCode) {
                            case 'Shop.Add':
                                self.permission.isAdd = response.data[i].permission
                                break;
                            case 'Shop.Edit':
                                self.permission.isEdit = response.data[i].permission
                                break;
                            case 'Shop.Delete':
                                self.permission.isDelete = response.data[i].permission
                                break;
                            case 'Shop.UpdateUse':
                                self.permission.isUpdateUse = response.data[i].permission
                                break;
                            case 'Shop.SelectUser':
                                self.permission.isSelectUser = response.data[i].permission
                                break;
                        }
                    }
                }).catch(function (error) {
                })
            }
        },
        watch: {
        },
        created: function () {
            this.initListData(1);
            this.initPermission();
        }
    }
</script>

<style scoped>
    .layout {
        background: #fff;
        border-radius: 8px;
        padding: 5px 10px;
    }

    #layout-title {
        overflow: hidden;
        padding: 5px;
        font-size: 16px;
        border-bottom: 1px solid #e8eaec;
    }

    #box-search {
        padding-top: 20px;
    }

    #layout-title-left {
        float: left;
		display: flex;
		justify-content: center;
		align-items: center;
    }

    #layout-title-right {
        float: right;
    }

    #head-img {
        text-align: center;
        margin-bottom: 20px;
    }

    #head-img-ava {
        cursor: pointer;
    }

        #head-img-ava:hover {
            transform: scale(1.1);
        }

    #page-box {
        margin-top: 20px;
        text-align: center;
    }
	
	.func-modal {
		background-color: white;
		border-radius: 7px;
		padding: 10px;
		margin-bottom: 20px;
	}
	
	.func-modal-title {
		font-size: 16px;
		font-weight: 700;
		overflow: hidden;
	}
	
	.func-modal-title-left{
		float: left;
	}
	
	.func-modal-title-right {
		float: right;
	}
	
	.box{
		margin-top: 15px;
	}
	
	.box-head {
		border-left: 5px solid #0ea391;
		padding-left: 10px;
		overflow: hidden;
	}
	
	.box-head-title {
		float: left;
		font-size: 15px;
		font-weight: 500;
		color: #000000;
	}
	
	.box-body {
		padding: 15px;
		overflow: hidden;
	}
	
	.box-body-item {
		margin-left: 20px;
		margin-right: 20px;
		float: left;
	}
	
	.box-head-title-tool {
		float: right;
	}
	
	.modal-header{
		display: flex;
		justify-content: left;
		align-items: center;
	}
</style>
